import { useTranslation } from "react-i18next";
import { AccordionItem, AccordionTrigger, AccordionContent } from "@tellescope/ui";
import { PriceVariantRow } from "./PriceVariantRow";
import type { StripeShopProduct, StripeShopPrice } from "./stripeShopTypes";

interface ProductSearchRowProps {
  product: StripeShopProduct;
  prices: StripeShopPrice[];
  pricesLoading: boolean;
  isPriceSelected: (stripePriceId: string) => boolean;
  onTogglePrice: (product: StripeShopProduct, price: StripeShopPrice) => void;
}

export const ProductSearchRow = ({
  product,
  prices,
  pricesLoading,
  isPriceSelected,
  onTogglePrice,
}: ProductSearchRowProps) => {
  const { t } = useTranslation("shop");

  return (
    <AccordionItem value={product.id} className="rounded-md border">
      <AccordionTrigger className="p-2 text-sm font-medium hover:no-underline">
        <span className="truncate">{product.name}</span>
      </AccordionTrigger>
      <AccordionContent className="pb-2">
        {pricesLoading ? (
          <p className="text-xs text-muted-foreground pl-8 py-1">{t("Loading prices…")}</p>
        ) : prices.length === 0 ? (
          <p className="text-xs text-muted-foreground pl-8 py-1">{t("No active prices for this product.")}</p>
        ) : (
          prices.map((price) => (
            <PriceVariantRow
              key={price.id}
              price={price}
              selected={isPriceSelected(price.id)}
              onToggle={() => onTogglePrice(product, price)}
            />
          ))
        )}
      </AccordionContent>
    </AccordionItem>
  );
};
